{
  "de-DE": {
    "model": {
      "profile": {
        "id": "Benutzer-ID",
        "userName": "Benutzername",
        "email": "E-Mail-Adresse",
        "emailConfirmed": "E-Mail-Adresse bestätigt.",
        "phoneNumber": "Telefonnummer",
        "phoneNumberConfirmed": "Telefonnummer bestätigt.",
        "twoFactorEnabled": "Zwei-Faktor-Authentifizierung aktiviert.",
        "lockoutEnd": "Ende der Sperrzeit.",
        "lockoutEnabled": "Sperrfunktion aktiviert.",
        "accessFailedCount": "Anzahl der fehlgeschlagenen Zugriffsversuche",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "picture": "Profilbild",
        "organisationName": "Organisation",
        "name": "Name",
        "roles": "Rollen"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Bestätigt"
      },
      "action": {
        "resetPassword.tooltip": "Senden Sie Anweisungen zum Zurücksetzen des Passworts per E-Mail an den Benutzer."
      },
      "message": {
        "resetPassword.success": "Eine E-Mail mit Anweisungen zum Zurücksetzen des Passworts wurde an den Benutzer gesendet."
      }
    }
  }
}